// Iter38 — module-scoped access control (frontend mirror of /app/backend/services/module_access.py).
//
// When user.module_access is null/empty → full access per role (existing behaviour).
// When set to a non-empty array → the user sees ONLY those modules (plus the
// cross-cutting ones below). RouteGuard <ModuleGuard> wraps protected routes.

export const MODULE_KEYS = [
  "incidents",
  "sorting",
  "tms",
  "engineering",
  "stock_lock",
  "material_movement",
  "8d",
  "fmea",
  "lpa",
  "analytics",
  "exec",
  "admin",
  "tenants",
  "chain",
];

export const CROSS_CUTTING = new Set([
  "dashboard",
  "sitrep",
  "notifications",
  "settings",
  "audit_trail",
]);

export const MODULE_LABELS = {
  incidents: "Incidents",
  sorting: "Sorting",
  tms: "TMS / Transport",
  engineering: "Engineering Requests",
  stock_lock: "Stock Locks",
  material_movement: "Logistics Requests",
  "8d": "8D Reports",
  fmea: "FMEA Module",
  lpa: "LPA Audits",
  analytics: "Analytics & MTTR",
  exec: "Executive View",
  admin: "Admin",
  tenants: "Tenants",
  chain: "Chain Map",
};

export function hasModuleAccess(user, moduleKey) {
  if (!user) return false;
  if (CROSS_CUTTING.has(moduleKey)) return true;
  if (user.role === "platform_admin") return true;
  const scope = user.module_access;
  if (!scope || !Array.isArray(scope) || scope.length === 0) return true;
  return scope.includes(moduleKey);
}
